export const NOCO_DB_BASE_URL = "https://answermagic.5cn.co.in/";

export const N8N_WEBHOOK_URL =
  "https://groot.5cn.co.in/webhook/create-referral";

export const YAAKE_URL = "https://yaake.cubebase.ai/clients/contacts/";
export const N8N_BASE_URL = "https://groot.5cn.co.in/webhook";
export const YAAKE_BASE_URL = "https://yaake-backend.cubebase.ai";

export enum REDUX_SLICES {
  ADMIN = "admin",
}
